
// import Typical from 'react-typical'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { getCaseType, isToday } from 'Utils';
import AiDateDisplay from './AiDateDisplay';
import AiLitigation from './AiLitigation';
// AiDisclaimer now renders inside AiSectionRail's card (see that file) so it
// reads as part of the AI insights instead of floating between the card and
// the site footer - no longer used directly here.
import AiProof from './AiProof';
import AiDifficulty from './AiDifficulty';
import { ChevronDown, CircleX } from 'lucide-react';


import AiInfo from './AiInfo';
import AiCaseEstimate from './AiCaseEstimate';
import AiProbability from './AiProbability';
import AiSectionRail from './AiSectionRail';
import AiEvidence from './AiEvidence';
import AiDefenceRisk from './AiRisksAndDefenses';
import AiCaseDifficulty from './AiCaseDifficulty';
import AiQuestionsList from './AiQuestionsList';
import AiFirms from './AiFirms';
import AiStrategy from './AiStrategy';
import AiTimelineAndOdds from './AiTimelineAndOdds';
import AiRisksAndDefenses from './AiRisksAndDefenses';
import AiCaseAnalysis from './AiCaseAnalysis';
import AiRetryNotice from './AiRetryNotice';

function AiIntegration({caseDetails, setUpdateComp}) {
   
    const aiChanceCount =  process.env.REACT_APP_AI_CHANCE_COUNT;
    const [aiResponse, setAiResponse] = useState(caseDetails?.aiEstimate);
    const [showAiInfoSection, setShowAiInfoSection] = useState(true);
  
    const [currentAiTab, setCurrentAiTab] = useState(1); // 1 = Firms & Estimate - first section shown in AiSectionRail's design order

    
    const [updateAiResponse, setUpdateAiResponse] = useState(false);
    function getTodayDateString() {
        return new Date().toISOString().split("T")[0]; // 'YYYY-MM-DD'
        }

    const [aiCountExpired, setAiCountExpired] = useState(null);
    useEffect(() => {
        setAiResponse(caseDetails?.aiEstimate);
        setAiCountExpired(caseDetails?.aiRequestHistory?.[getTodayDateString()] ? 
       ( caseDetails?.aiRequestHistory?.[getTodayDateString()] >= aiChanceCount
        ? true
        : false)
        :
        false)
    },[caseDetails]);
    function buildAiContent() {
        switch(currentAiTab) {
            case 0:
                return (
                        <>
                       
                        <AiProbability 
                          aiConfidenceScore={caseDetails?.aiConfidenceScore}
                            probabilityNonZero={caseDetails?.aiProbability?.probabilityNonZero}
                            probabilitySettlement={caseDetails?.aiProbability?.probabilitySettlement}
                            aiEarlySettlementRecommendation={caseDetails?.aiEarlySettlementRecommendation}
                            aiSuitability={caseDetails?.aiSuitability}
                            aiEstimateLowerValue={caseDetails?.aiEstimateLowerValue}
                            aiEstimateUpperValue={caseDetails?.aiEstimateUpperValue}
                        />
                        </>)
                        break;
        case 1:
            return (
                <div className='grid grid-cols-1 w-full'>
                    <AiFirms   
                    localFirms={caseDetails?.aiLocalFirms}
                    smallFirms={caseDetails?.aiSmallFirms}
                    caseTitle={caseDetails?.caseTitle}
                    caseId = {caseDetails?._id}
                    firmMatchStatus={caseDetails?.aiFirmMatchStatus}
                    setUpdateComp={setUpdateComp}
                        />
                </div>
            );
            break;
            case 2:
                return (
                    <div className='grid grid-cols-1 w-full'>
                        
                              <AiTimelineAndOdds
                                aiDate={caseDetails?.aiDate}
                                ailitigation={caseDetails?.ailitigation}
                                aiEvidence={caseDetails?.aiEvidence}
                                />
                                
                            </div>);
                            break;
            
            case 3:
                    return (
                        <div className='grid grid-cols-1 w-full'>
                            <AiRisksAndDefenses
                                aiPlaintiffFault={caseDetails?.aiPlaintiffFault}
                                aiDefences={caseDetails?.aiDefences}
                                aiRisks={caseDetails?.aiRisks}
                                />
                             </div>
                    );
                    break;  
            case 4:
                    return (
                        <div className='grid grid-cols-1 w-full'>
                            <AiCaseAnalysis 
                              aiDifficulty={caseDetails?.aiDifficulty}
                              aiDataGaps={caseDetails?.aiDataGaps}
                              aiQuestions={caseDetails?.aiQuestions}
                            />
                        </div>
                    );
                    break;    
        }}
                    
  // Adverse party research gates valuation only now - if research failed,
  // valuation never started (it needs research's real output - see
  // caseValuationPrompt.js), so there's nothing yet to show for the
  // estimate/timeline/risks/case-analysis tabs, and one generic retry
  // re-triggers research + valuation together (see /retry/partyResearch in
  // server/routes/case.js). Firm-match, however, runs completely
  // independently of research (fired as its own request - see
  // CreateFormLanding.jsx and POST /:caseId/firmMatch) and can very well
  // have already finished even though research failed, so it still renders
  // below if it has something to show.
  if (caseDetails?.aiPartyResearchStatus === 3) {
    return (
      <div className='flex flex-col w-full items-center text-gray-800 justify-center'>
        <div className='w-full flex justify-center flex-col items-center'>
          <div className='flex flex-col w-full lg:py-8 justify-between items-center gap-4'>
            <div className='w-full'>
              <AiRetryNotice
                type="research"
                status={caseDetails?.aiPartyResearchStatus}
                caseId={caseDetails?._id}
                setUpdateComp={setUpdateComp}
                label="AI insights"
              />
            </div>
            {(caseDetails?.aiFirmMatchStatus === 2 || caseDetails?.aiFirmMatchStatus === 3) && (
              <div className='w-full'>
                <AiFirms
                  localFirms={caseDetails?.aiLocalFirms}
                  smallFirms={caseDetails?.aiSmallFirms}
                  caseTitle={caseDetails?.caseTitle}
                  caseId={caseDetails?._id}
                  firmMatchStatus={caseDetails?.aiFirmMatchStatus}
                  setUpdateComp={setUpdateComp}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className='flex flex-col w-full  items-center text-gray-800 justify-center'>

                {/* <div className='text-lg px-10 flex  w-full rounded font-bold flex items-center cursor-pointer'>
                    AI Powered Key Insights About Your {getCaseType(caseDetails?.caseType)} Case

                </div> */}
                <div>

                </div>
                {showAiInfoSection &&
                <div
                className='w-full flex justify-center flex-col items-center'>
                    <div className='flex flex-col w-full lg:py-8  justify-between  items-center'>
                        <div className='w-full'>
                          <AiRetryNotice
                            type="valuation"
                            status={caseDetails?.aiValuationStatus}
                            caseId={caseDetails?._id}
                            setUpdateComp={setUpdateComp}
                            label="case estimate"
                          />
                        </div>
                        <AiSectionRail
                        currentAiTab={currentAiTab}
                        setCurrentAiTab={setCurrentAiTab}
                        content={<div className='w-full '>
                        {currentAiTab === 1 &&
                        <AiCaseEstimate
                        caseDetails={caseDetails}
                        aiResponse={aiResponse}
                        setAiCountExpired={setAiCountExpired}
                        aiCountExpired={aiCountExpired}
                        setUpdateComp={setUpdateComp}
                            />}
                            {buildAiContent()}</div>}
                        />

                    </div>
                </div>
                }
       
    </div>
    </>
  )
}

export default AiIntegration;
